import React from "react";
import { useParams } from "react-router";
import query from "../../server/constants.api";
import useFetch from "../../server/useFetch";
import { PageContent } from "../../styles/global/Pages.styled";
import { RegisterBuildingHelper } from "../Global/Organism/RegisterDetail/RegisterBuildingHelper";
import { RegisterComponent } from "../Global/Organism/RegisterDetail/RegisterComponent";
import { RegisterWeatherServiceHelper } from "../Global/Organism/RegisterDetail/RegisterWeatherServiceHelper";

export const RegisterDetail = () => {
  const { id } = useParams();

  const { data: itemData,
  } = useFetch("/registry", "itemData", {
    id: id
  }, null, null, query.middlewareURL);

  return (
    <PageContent style={{ height: '100%' }}>
      {itemData ?
        <RegisterComponent item={itemData} tabsHelper={getTabsHelper(itemData)} />
        : null}
    </PageContent>
  );
};

const getTabsHelper = (item) => {
  const classe = item?.class;
  switch (classe) {
    case 'Office':
      return RegisterBuildingHelper;
    default:
      return RegisterWeatherServiceHelper;
  }
}